import { EventEmitter, OnChanges } from '@angular/core';
import { Product } from '../../../core/models/product';
import { CombinedFacets } from '../../../facets/models/facet';
import { CartProduct } from '../../../cart/models/cart-models';
import { upwardsQuantity, minQuantity, stepping } from '../../../core/helpers/prices';
import * as moment from 'moment';
import { FacetValuesPipe } from '../../pipes/facet-values.pipe';
import { canBuyProduct } from '../../../core/helpers/product';
var ProductTableItemComponent = /** @class */ (function () {
    function ProductTableItemComponent(facetValuesPipe) {
        this.facetValuesPipe = facetValuesPipe;
        this.startQuantity = 0;
        this.onDetails = new EventEmitter();
        this.onAddCart = new EventEmitter();
        this.onFavoriteToggle = new EventEmitter();
    }
    ProductTableItemComponent.prototype.ngOnChanges = function () {
    };
    ProductTableItemComponent.prototype.getActualQuantity = function (cartQuantity) {
        this.startQuantity = cartQuantity > 0
            ? cartQuantity
            : 0;
    };
    Object.defineProperty(ProductTableItemComponent.prototype, "thumbUrl", {
        get: function () {
            if (this.product && this.product.assets && this.product.assets.imgs && this.product.assets.imgs.length > 0) {
                var img = this.product.assets.imgs.find(function (img) { return img.type === 'thumb'; });
                if (img && img.src) {
                    return img.src;
                }
            }
            return '/assets/images/no-image-placeholder.png';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTableItemComponent.prototype, "price", {
        get: function () {
            if (this.product && this.product.price && this.product.price.prices && this.product.price.prices.length) {
                return this.product.price.prices[0].price;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTableItemComponent.prototype, "currency", {
        get: function () {
            if (this.product && this.product.price && this.product.price.prices && this.product.price.prices.length) {
                return this.product.price.prices[0].currency;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTableItemComponent.prototype, "actualQuantity", {
        get: function () {
            return upwardsQuantity(this.product, this.quantity || this.startQuantity);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTableItemComponent.prototype, "minQuantity", {
        get: function () {
            return minQuantity(this.product);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTableItemComponent.prototype, "stepping", {
        get: function () {
            return stepping(this.product);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTableItemComponent.prototype, "canBuy", {
        get: function () {
            return canBuyProduct(this.product, this.allowOutOfStockOrdering);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductTableItemComponent.prototype, "isProductInBackorder", {
        get: function () {
            return (this.product && this.product.backorderInfo && this.product.backorderInfo.totalInBackorder > 0);
        },
        enumerable: true,
        configurable: true
    });
    ProductTableItemComponent.prototype.getWeekAndYearFromDateString = function (value) {
        var date = moment(value);
        if (date.isValid()) {
            return moment(value).format('w, YYYY');
        }
        return '';
    };
    ProductTableItemComponent.prototype.getWeekFromDateString = function (value) {
        var date = moment(value);
        if (date.isValid()) {
            return moment(value).format('w');
        }
        return '';
    };
    ProductTableItemComponent.prototype.addCart = function (event) {
        this.onAddCart.emit({
            product: this.product._id,
            quantity: event.quantity
        });
    };
    ProductTableItemComponent.prototype.toggleFavorite = function (e) {
        e.stopPropagation();
        this.onFavoriteToggle.emit({
            isFavorite: this.isFavorite,
            product: this.product
        });
    };
    ProductTableItemComponent.prototype.openDetails = function () {
        this.onDetails.emit(this.product);
    };
    Object.defineProperty(ProductTableItemComponent.prototype, "inCart", {
        get: function () {
            return !!this.cartProduct && this.cartProduct.inCart;
        },
        enumerable: true,
        configurable: true
    });
    ProductTableItemComponent.prototype.getFacetValues = function (facetCode) {
        return this.facetValuesPipe.transform(this.product.facets, facetCode, this.combinedFacets);
    };
    return ProductTableItemComponent;
}());
export { ProductTableItemComponent };
